export const nameRules = [
    (v: string) => !!v || 'Поле обязательно',
    (v: string) => (v && v.length >= 12) || 'Название должно быть больше 12 символов',
  ];
